export default Object.freeze(
    {
        "customerProfile": {
            "id": 1,
            "label": "Customer Profile:",
            "description": "This is the information we require from our customers about their business as part of our carrier’s KYC (Twilio Know Your Customer). This includes their business name, a real HQ address, an authorized representative, their Business Identification Numbers, etc. This information is gathered in a Customer Profile and goes through multiple stages in its lifecycle indicated by its status, which will be one of the following values:",
            "statuses": [
                "Staged",
                "Draft",
                "In Review",
                "Twilio Approved",
                "Twilio Rejected"
            ],
            "turnAroundTime": {
                "label": "Turnaround Time (TAT):",
                "description": "This process is almost instantaneous but can take up to 24 hours to complete."
            }
        },
        "a2pTrustProduct": {
            "id": 2,
            "label": "A2P Trust Product:",
            "description": "This contains information about the business from the vetted customer profile and their Brand.",
            "requirement": {
                "label": "Requirement:",
                "description": "Draft Customer Profile"
            }
        },
        "a2pBrand": {
            "id": 3,
            "label": "A2P Brand:",
            "description": "This is a requirement for the A2P 10DLC messaging compliance. The business information undergoes a secondary vetting process that can result in increased throughput and messaging limits. The business will get a Trust Score that defines the long code messaging throughput (MPS) to the US networks and the daily message restrictions to T-Mobile.",
            "requirement": {
                "label": "Requirement:",
                "description": "Pending Review A2P Trust Product"
            },
            "turnAroundTime": {
                "label": "Turnaround Time (TAT):",
                "description": "This process can take up to 72 hours to complete."
            }
        },
        "a2pMessagingService": {
            "id": 4,
            "label": "A2P Campaign:",
            "description": "This is the other requirement for the A2P 10DLC messaging compliance. The A2P campaign’s use case, description, sample messages, opt-in workflow and other details such as embedded phone numbers and/or links are submitted to be vetted by Mobile Network Operators (MNOs). Once verified, the phone numbers will be added to the A2P Messaging Service and will undergo an onboarding period with the MNOs.",
            "requirement": {
                "label": "Requirement:",
                "description": "Approved A2P Brand"
            },
            "turnAroundTime": {
                "label": "Turnaround Time (TAT):",
                "description": "The A2P Campaign verification and the phone number onboarding period can take up to 10 business days to complete."
            }
        },
        "stirShaken": {
            "id": 5,
            "label": "STIR/SHAKEN:",
            "description": "This voice compliance product reduces the likelihood of having the phone numbers labeled as &lt;b&gt;spam-likely&lt;/b&gt; by verifying the legitimacy of phone calls and enables service providers to determine whether a call is coming from a valid source.",
            "requirement": {
                "label": "Requirement:",
                "description": "Approved Customer Profile"
            },
            "turnAroundTime": {
                "label": "Turnaround Time (TAT):",
                "description": "This process is almost instantaneous but can take up to 72 hours to complete."
            }
        },
        "voiceIntegrity": {
            "id": 6,
            "label": "Voice Integrity:",
            "description": "This is a voice compliance product that addresses &lt;b&gt;spam-labeling of legitimate calls&lt;/b&gt; by registering the phone numbers with carrier's analytic vendors for T-Mobile and Sprint (First Orion), and AT&T (Hiya) to remediate phone numbers with negative reputation.",
            "requirement": {
                "label": "Requirement:",
                "description": "Approved Customer Profile"
            },
            "comingSoon": {
                "label": "Coming Soon:",
                "description": [
                    {
                        "label": "Integration with the analytic engine for Verizon Wireless (TNS)",
                        "description": "If the account has already signed up for Voice Integrity, there will not be any additional action needed. We will automatically remediate the reputation of your registered phone numbers with Verizon Wireless when available."
                    },
                    {
                        "label": "Phone Number Reputation Monitoring",
                        "description": "You will eventually be able to monitor the reputation of your phone numbers by looking up the reputation of each phone number on each network and also signing up for notifications for reputation degradation."
                    }]
            },
            "turnAroundTime": {
                "label": "Turnaround Time (TAT):",
                "description": [
                    "Twilio's Compliance Operations team is responsible for vetting the Business Profile. The time to vet can be between 24 to 48 hours.",
                    "The time to remediate the phone numbers registered to Voice Integrity from spam label can be between 24 to 48 hours."
                ]
            }
        },
        "cnam": {
            "id": 7,
            "label": "CNAM:",
            "description": "Also known as CallerID Name, is a voice compliance product that helps &lt;b&gt;increase pickup rates&lt;/b&gt; for outbound calls. The display name will appear on your customers' landlines and mobile phones when enabled by the subscriber.",
            "requirement": {
                "label": "Requirement:",
                "description": "Approved Customer Profile"
            },
            "turnAroundTime": {
                "label": "Turnaround Time (TAT):",
                "description": [
                    "The registration process can take up to 48 hours to complete. ",
                    "Please note that it may take up to 4 weeks (or more) for the new CNAM to propagate through the system of various CNAM databases but it should be updated on most databases within two weeks."
                ]
            }
        },
        "rcs": {
            "id": 14,
            "label": "RCS Sender:",
            "description": "Once the RCS profile reaches 'Approved' status, initiate synchronization. If the profile is pre-attached to a Messaging Service, sync metadata directly. If unattached, the profile must be mapped to a Messaging Service. Note: This association is cascading and will apply configuration changes to all related lines mapped to the Messaging Service.",
            "requirement": {
                "label": "Requirement:",
                "description": "Approved Messaging Service with A2P Campaign"
            }
        },
    }
)
